import { useQuery } from "@tanstack/react-query";
import { platformRepository } from "../repositories/platform";

export const useDashboardData = () =>
  useQuery({ queryKey: ["dashboard"], queryFn: () => platformRepository.dashboard() });
export const useCustomersData = () =>
  useQuery({ queryKey: ["customers"], queryFn: () => platformRepository.customers() });
export const useSalesData = () =>
  useQuery({ queryKey: ["sales"], queryFn: () => platformRepository.sales() });
export const useContractsData = () =>
  useQuery({ queryKey: ["contracts"], queryFn: () => platformRepository.contracts() });
export const useInvoicesData = () =>
  useQuery({ queryKey: ["invoices"], queryFn: () => platformRepository.invoices() });
export const useCommissionsData = () =>
  useQuery({ queryKey: ["commissions"], queryFn: () => platformRepository.commissions() });
export const useTelemedicineData = () =>
  useQuery({ queryKey: ["telemedicine"], queryFn: () => platformRepository.telemedicine() });
export const useIntegrationsData = () =>
  useQuery({ queryKey: ["integrations"], queryFn: () => platformRepository.integrations() });
export const useTeamData = () =>
  useQuery({ queryKey: ["team"], queryFn: () => platformRepository.team() });
